'use strict';

(function() {
    function initActiveLabels() {
        document.querySelectorAll('.product-chooser__form').forEach(function(form) {
            let labels = form.querySelectorAll('label.product-chooser__option');

            function updateActiveLabel() {
                labels.forEach(function(l) {
                    let radio = l.querySelector('input[type="radio"]');
                    l.classList.toggle('active', radio.checked);
                });
            }

            updateActiveLabel();

            labels.forEach(function(label) {
                let radio = label.querySelector('input[type="radio"]');
                radio.addEventListener('change', function() {
                    updateActiveLabel();
                    if (radio.dataset.target) {
                        form.action = radio.dataset.target;
                    }
                });
            });
        });
    }

    function initSticky() {
        let containers = document.querySelectorAll('.product-chooser__onscroll');
        let container = null;
        for (let i = 0; i < containers.length; i++) {
            if (containers[i].offsetParent !== null) {
                container = containers[i];
                break;
            }
        }
        if (!container) {
            return;
        }

        let form = container.querySelector('.product-chooser__form');
        let stickyBar = container.parentElement.querySelector('.product-chooser__sticky-bar');
        if (!form || !stickyBar) return;

        stickyBar.querySelector('.product-chooser__button').addEventListener('click', function() {
            form.submit();
        });

        let observer = new IntersectionObserver(function(entries) {
            stickyBar.classList.toggle('product-chooser__sticky-bar--visible', !entries[0].isIntersecting);
        });
        observer.observe(container);
    }

    function initDataOutput() {
        let mql = window.matchMedia('(max-width: 767px)');

        function update() {
            let value = mql.matches ? 'mini' : 'main';
            document.querySelectorAll('.product-chooser__form').forEach(function(form) {
                form.dataset.output = value;
            });
        }

        update();
        mql.addEventListener('change', update);
    }

    function init() {
        initActiveLabels();
        initSticky();
        initDataOutput();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
